import {number, shape, string} from 'react-proptypes';
import ToolLogoSvg from 'images/orv/logo.svg';
import EqualGraphSvg from 'images/orv/coverages/equal.svg';
import LinearGraphSvg from 'images/orv/coverages/linear.svg';
import AnnuityGraphSvg from 'images/orv/coverages/annuity.svg';

export default {
  app: 'orv',
  framed: false,
  logo: ToolLogoSvg,
  pages: ['flow', 'applicant', 'partner', 'coverage', 'final'],
  syncing: false,
  broken: false,
  recalculating: null,
  settings: null,
  input: {
    flow: '',
    applicant_dob: '',
    applicant_smokes: false,
    has_partner: false,
    partner_dob: '',
    partner_smokes: false,
    duration: 30,
    coverage: null,
    coverageType: '',
    premium: null,
    payment: 1,
    endDate: '',
    selectedOrv: {},
  },
  output: {
    errors: {},
  },
};

export const whiteListUrlParams = [
  'flow',
  'applicant_dob',
  'applicant_smokes',
  'has_partner',
  'partner_dob',
  'partner_smokes',
  'duration',
  'coverage',
  'coverageType',
  'premium',
  'payment',
  'endDate',
  'mvCompany',
  'description',
  'premiumPerMonth',
  'yearsLeft',
  'totalSaving'
]

export const coverageOptions = [
  {
    value: '001',
    description: 'Gelijk-blijvend',
    svg: EqualGraphSvg,
    info: `
      Kies je voor een gelijkblijvende dekking, dan keert de verzekering altijd hetzelfde bedrag uit bij overlijden. 
      Het maakt dus niet hoe lang de verzekering al loopt, wanneer iemand overlijdt. 
      Deze variant is vaak de duurste optie per verzekeraar.
    `,
  },
  {
    value: '002',
    description: 'Lineair dalend',
    svg: LinearGraphSvg,
    info: `
      Een overlijdensrisicoverzekering met een lineair dalende uitkering is meestal het goedkoopst. 
      Het bedrag dat de verzekeraar bij overlijden uitkeert, neemt elk jaar af met een vast bedrag. 
      In het eerste jaar is de uitkering het hoogst, in het laatste jaar het laagst.
    `,
  },
  {
    value: '003',
    description: 'Annuïtair dalend',
    svg: AnnuityGraphSvg,
    info: `
      Een overlijdensrisicoverzekering met een annuïtair dalende dekking wordt vaak gekozen bij een annuïteitenhypotheek. 
      Bij zo'n hypotheek los je jaarlijks een bedrag af. 
      Het bedrag dat de verzekeraar bij overlijden uitkeert is (ongeveer) gelijk aan de resterende hypotheekschuld.
    `,
  },
];

export const premiumPaymentScheme = [
  {label: 'Maand', value: 1},
  {label: 'Kwartaal', value: 3},
  {label: 'Halfjaar', value: 6},
  {label: 'Jaar', value: 12},
];

export const flowTypes = {
  new: 'select_button_new_orv',
  existing: 'select_button_existing_orv',
};

export const statusTypes = {
  lead: 'L',
  prospect: 'P',
};

export const shapeResult = shape({
  description: string,
  mvCompany: string,
  mvCompanyCode: string,
  premiumPerMonth: number,
  premiumTotal: number,
  productId: number,
  totalSaving: number,
  yearsLeft: number,
});

export const messageBarText = `
	Wij sorteren de producten van diverse aanbieders in dit overzicht op basis van de totale premie die je over de hele looptijd betaalt. 
	Daarom kan een verzekering met een lagere eerste premie iets lager staan, wanneer het premiebedrag in de loop van de jaren stijgt.
`
